var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "videoShowContainer" }, [
      _c("div", {
        staticClass: "delete is-large",
        staticStyle: {
          position: "absolute",
          top: "5px",
          left: "5px",
          "background-color": "black",
          "z-index": "50"
        },
        on: { click: _vm.$root.$refs.routerView.closeVideo }
      }),
      _vm._v(" "),
      _c("video", {
        staticClass: "videoPlayer",
        attrs: {
          id: "htmlVideo",
          src: _vm.$root.$refs.routerView.vid,
          controls: "",
          autoplay: "",
          poster: require("@/assets/img/vidPoster.png")
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee0cb374", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee0cb374","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video1.vue
// module id = null
// module chunks = 